import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { Router, CanActivate } from '@angular/router';
import { AuthService } from '../app-services/auth.service';
import { FormsModule } from '@angular/forms';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'app-forgot',
  templateUrl: './forgot.component.html',
  styleUrls: ['./forgot.component.css']
})
export class ForgotComponent implements OnInit {
  emailErrors;
  emailSent = false;

  constructor(private authService: AuthService) { }

  ngOnInit() {
  }


  public onSubmit(value: any) {

    this.emailErrors = '';

    this.authService.reset(value).subscribe(res => {
      // display message
      this.emailSent = true;
    },
      error => {
        if (error.status === 422) {
          if (error.json().error.errors.email) {
            this.emailErrors = error.json().error.errors.email[0];
          }
        }
      });
  }

}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/mmam/angular/src/app/forgot/forgot.component.ts